import { Component, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { FormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MasterService } from "@frontend/app/serivces/master.service";
import { GlobalService } from "@frontend/app/serivces/global.service";
import { SVG_ICONS } from "@frontend/app/models/icons";
import { SanitizerPipe } from "../../pipes/sanitizer.pipe";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { AddMenuComponent } from "../masters/add-menu/add-menu.component";
@Component({
  selector: "app-navigation",
  imports: [CommonModule, FormsModule, MatIconModule, MatCheckboxModule, SanitizerPipe],
  templateUrl: "./navigation.component.html",
  styleUrl: "./navigation.component.scss",
  animations: [
    trigger("indicatorRotate", [
      state("collapsed", style({ transform: "rotate(0deg)" })),
      state("expanded", style({ transform: "rotate(180deg)" })),
      transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4,0.0,0.2,1)")),
    ]),
  ],
})
export class NavigationComponent  implements OnInit{
  private masterService=inject(MasterService);
  private dialog=inject(MatDialog);
  private _GlobalService=inject(GlobalService);
  private dialogService=inject(MatDialog);
 
  ngOnInit(): void {
    this.GetAllMenuMaster();
  }

  masterMenuList: any[] = [];
  readonly SVG_ICONS=SVG_ICONS

  GetAllMenuMaster() {
    this.masterMenuList = [];
    this.masterService.getMenuList(1, 100, "").subscribe((res: any) => {
      const { Table } = res;
      if (Table?.length) {
        this.masterMenuList = this._GlobalService.menuSetter(Table);
      }
    });
  }

  onClickAddMenu() {
    const dialogConfig = new MatDialogConfig();
    // this.dialogService.matDialogDefaultConfig(dialogConfig);
    dialogConfig.width = "60%";
    const dialogRef = this.dialog.open(AddMenuComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.GetAllMenuMaster();
      }
    });
  }

  OnClickAddNavigation(item?: any) {
    const dialogConfig = new MatDialogConfig();
    // this.dialogService.matDialogDefaultConfig(dialogConfig);
    dialogConfig.width = "60%";
    dialogConfig.data = {
      IsEdit: false,
      MenuModal: item ? item : null,
      ParentMenuID: item ? item.MenuID : 0,
    };
    const dialogRef = this.dialog.open(AddMenuComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.GetAllMenuMaster();
      }
    });
  }

  onClickEditItem(item: any) {
    const dialogConfig = new MatDialogConfig();
    // this.dialogService.matDialogDefaultConfig(dialogConfig);
    dialogConfig.width = "60%";
    dialogConfig.data = {
      IsEdit: true,
      MenuModal: item,
      ParentMenuID: item.MenuID,
    };
    const dialogRef = this.dialog.open(AddMenuComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.GetAllMenuMaster();
      }
    });
  }

  // onChangeStatus(row: any) {
  //   const TempModal = new MenuMaster();
  //   TempModal.MenuID = row.MenuID;
  //   TempModal.IsActive = !row.IsActive;
  //   this._MasterService.AddMenuActive(TempModal).subscribe((res: any) => {
  //     this.GetAllMenuMaster();
  //   });
  // }

  // onChangeOrder(row: any) {
  //   const TempModal = new MenuMaster();
  //   TempModal.MenuID = row.MenuID;
  //   TempModal.iOrder = row.iOrder;
  //   // this.masterService.AddMenuOrder(TempModal).subscribe((res: any) => {
  //   //   this._GlobalService.sortMenuByOrder(this.masterMenuList);
  //   // });
  // }

  onClickMenuItem(item: any) {
    if (item.ChildList?.length === 0) return;
    item.IsExpanded = !item.IsExpanded;
  }
}
